import React, { useEffect, useState } from "react";
import "./Google.scss"

const GoogleLoginButton = () => {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const name = params.get("name");
    const email = params.get("email");

    if (name && email) {
      setUser({ name, email });
      window.history.replaceState(null, "", window.location.pathname);
    }
  }, []);

  const handleLogin = () => {
    window.location.href = "http://localhost:3001/auth/google";
  };

  return (
    <div className="google-signin" onClick={handleLogin}>
      <img src="./google.png" alt="Google Logo" className="google-logo" />
      <span className="google-text">Sign in with Google</span>
    </div>
  );
};

export default GoogleLoginButton;
